export enum UserSetCardsActionTypes {
  FILTERED = 'user-set-cards/FILTERED',
}
